// extracted by mini-css-extract-plugin
export var bottomContainer = "p_bB";
export var buttons = "p_bC";
export var icon = "p_bz";
export var link = "p_by";
export var section = "p_j";
export var social = "p_bx";
export var text = "p_bw";
export var title = "p_g";
export var topContainer = "p_bv";
export var videoContainer = "p_bs";
export var videoWrapper = "p_bt";